import localizationEnJson from './translations/localization.en.json';
import localizationDeJson from './translations/localization.de.json';
import { Localizations } from './definitions/enums';

export const getLocalization = (language: Localizations) => {
    switch (language) {
        case Localizations.en:
            return localizationEnJson;
        case Localizations.de:
            return localizationDeJson;
        default:
            return localizationEnJson;
    }
};
